// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { css } from 'emotion';
import { DateUtils } from '@fulcrumapp/fulcrum-core';
import { CloseIcon, GalleryIcon, MapIcon } from '../../icons';
import request from '../../api/browser';
import Track from './track';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

export default class MediaCaptionView extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    displayableItem: PropTypes.object.isRequired,
    metadata: PropTypes.object,
    onClose: PropTypes.func,
    onMapToggle: PropTypes.func.isRequired,
    track: PropTypes.instanceOf(Track),
    onGalleryClick: PropTypes.func,
    mediaValueItems: PropTypes.array,
    mapVisible: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.fetchedCoordinates = [0, 0];
    this.state = {
      location: null,
    };
  }

  componentDidMount() {
    this.fetchLocation();
  }

  componentDidUpdate() {
    this.fetchLocation();
  }

  render() {
    const { styles } = MediaCaptionView;

    return (
      <div className={cx(this.props.className, styles.container)}>
        {this.renderTitle()}
        <div className={styles.buttonsContainer}>
          {this.renderThumbnailGalleryButton()}
          {this.renderMapButton()}
          {this.renderCloseButton()}
        </div>
      </div>
    );
  }

  renderCloseButton() {
    if (!this.props.onClose) {
      return null;
    }

    const { styles } = MediaCaptionView;

    return (
      <div
        className={styles.close}
        onClick={this.props.onClose}
      >
        <CloseIcon style={{ fill: '#f00' }} />
      </div>
    );
  }

  renderThumbnailGalleryButton() {
    if (this.props.onGalleryClick) {
      return null;
    }

    if (this.props.mediaValueItems?.length > 1) {
      return (
        <div
          className={styles.close}
          onClick={this.props.onClose}
        >
          <GalleryIcon style={{ fill: '#f00' }} />
        </div>
      );
    }

    return null;
  }

  renderMapButton() {
    if (
      !this.props.displayableItem.supportsMapView
      || this.props.metadata?.stored !== true
    ) {
      return null;
    }

    const { styles } = MediaCaptionView;

    return (
      <div
        className={css(styles.mapToggle, this.props.mapVisible && styles.inset)}
        onClick={this.props.onMapToggle}
      >
        <MapIcon />
      </div>
    );
  }

  renderTitle() {
    const { styles } = MediaCaptionView;

    return (
      <div className={styles.caption}>
        {this.props.displayableItem.item.caption && <span className={styles.captionLabel}>{this.props.displayableItem.item.caption}</span>}
        {this.renderCapturedBy()}
        {this.renderLocation()}
        {this.renderTimestamp()}
      </div>
    );
  }

  renderLocation() {
    if (!this.state.location) {
      return null;
    }

    const { styles } = MediaCaptionView;

    const locationParts = [];

    if (this.state.location.address.restaurant) {
      locationParts.push(this.state.location.address.restaurant);
    }

    if (this.state.location.address.road) {
      locationParts.push(this.state.location.address.road);
    }

    if (this.state.location.address.neighbourhood) {
      locationParts.push(this.state.location.address.neighbourhood);
    }

    if (this.state.location.address.village) {
      locationParts.push(this.state.location.address.village);
    }

    if (this.state.location.address.city) {
      locationParts.push(this.state.location.address.city);
    }

    return (
      <span>
        <span className={styles.near}>near</span>
        <span title={`${this.state.location.display_name} (${this.state.location.licence})`}>{locationParts.join(', ')}</span>
      </span>
    );
  }

  renderCapturedBy() {
    const { styles } = MediaCaptionView;

    if (!(this.props.metadata && this.props.metadata.updated_by)) {
      return null;
    }

    return (
      <span>
        <span className={styles.capturedBy}>Captured by</span>
        {this.props.metadata.updated_by}
      </span>
    );
  }

  renderTimestamp() {
    if (!this.props.metadata) {
      return null;
    }

    const { styles } = MediaCaptionView;

    const label = DateUtils.formatRelativeTimestamp(DateUtils.parseISOTimestamp(this.props.metadata.created_at));

    return (
      <span className={styles.timestamp}>{label}</span>
    );
  }

  get location() {
    if (this.props.track) {
      return this.props.track.representativePoint;
    } if (this.props.metadata.longitude != null && this.props.metadata.latitude != null) {
      return [this.props.metadata.longitude, this.props.metadata.latitude];
    }

    return null;
  }

  async fetchLocation() {
    // Don't fetch null / undefined data
    // !this.props.metadata.latitude doesn't work here because it also considers 0 as falsy
    if (!this.props.metadata
      || this.props.metadata.latitude == null
      || this.props.metadata.latitude === undefined) return;
    // Check to see if there has been a change in the location
    if (this.props.metadata.latitude === this.fetchedCoordinates[0]
      && this.props.metadata.longitude === this.fetchedCoordinates[1]) return;
    // fetchedCoordinates holds the last updated coordinates
    // If we made fetchedCoordinates a state variable we would re-trigger this function an additional time on a new render
    this.fetchedCoordinates = [this.props.metadata.latitude, this.props.metadata.longitude];
    // If there has been a change and lat / long are not 0, fetch location and set location state to response
    if (this.props.metadata.latitude !== 0 && this.props.metadata.longitude !== 0) {
      const options = {
        url: `https://nominatim.openstreetmap.org/search?q=${this.location[1]},${this.location[0]}&format=json&addressdetails=1`,
      };
      await request(options, (err, res, body) => {
        if (err) {
          throw err;
        }
        this.setState({ location: JSON.parse(body)[0] });
      });
    } else {
      // If there has been a change and lat / long are 0, do not execute request and wipe location state
      this.setState({ location: null });
    }
  }
}

const styles = cssInJS({
  container: {
    fontFamily: THEME.fontFamily,
    backgroundColor: '#fff',
    borderBottom: '1px solid #d9d9d9',
    borderTop: '5px solid red',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  caption: {
    marginLeft: 16,

    '@phone': {
      marginRight: 14,
    },
  },

  buttonsContainer: {
    display: 'flex',
    marginLeft: 10,
  },

  mapToggle: {
    width: 50,
    height: 50,
    float: 'right',
    padding: 8,
    cursor: 'pointer',
    borderLeft: '1px solid #d9d9d9',
    fill: '#eb1300',

    '@phone': {
      display: 'none',
    },
  },

  close: {
    width: 50,
    height: 50,
    float: 'right',
    padding: 8,
    cursor: 'pointer',
    borderLeft: '1px solid #d9d9d9',
    fill: '#eb1300',
  },

  near: {
    marginLeft: 5,
    marginRight: 5,
    color: '#888',
    fontSize: 14,
  },

  timestamp: {
    color: '#888',
    fontSize: 14,
    marginLeft: 5,
  },

  capturedBy: {
    color: '#888',
    fontSize: 14,
    marginRight: 5,
  },

  captionLabel: {
    marginRight: 5,
  },

  inset: {
    boxShadow: 'inset 0px 0px 8px 0px rgba(0,0,0,0.2)',
  },
});

MediaCaptionView.styles = styles;
